import MainNews from "./MainNews";

export default MainNews